export const getDynamicPrecision = (value) => {
    return value?.toString().split('.')[1]?.length === 3 ? 3 : 2
  }
  